<template>
  <div>
    <div id="uploadFolder" class="modal fade" tabindex="-1" aria-hidden="true" aria-labelledby="uploadFolder">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content modal-content1">
          <div class="modal-header">
            <h5 id="ModalLabel" class="modal-title">
              {{ $t('key_filemodalselector_documentation') }} - {{ entityNumber }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body modal-body1">
            <div class="container-fluid p-0 h-100">
              <div class="row h-100">
                <div class="col-lg-3 ps-0">
                    <div class="card-body p-0 overflow-auto border-0 sidenav navbar-vertical navbar-expand-xs position-absolute border-radius-xl">
                      <div class="w-auto navbar-collapse h-100 overflow-hidden ps-0">
                        <ul class="navbar-nav ps-0">
                          <li class="nav-item mt-3 ps-0">
                            <SidenavFolderItem :nav-text="$t('key_fileModalConfirmation_files_folder')" :class="folderSelected === 'doc' ? 'active' : ''" item-ref="doc" @switch="changeFolder">
                              <template #icon>
                                <i class="fa-solid fa-folder-open" aria-hidden="true" :class="folderSelected === 'doc' ? 'icon-white' : 'icon-primary'"></i>
                              </template>
                            </SidenavFolderItem>
                          </li>
                          <li class="nav-item ps-0">
                            <SidenavFolderItem :nav-text="$t('key_fileModalConfirmation_images_folder')" :class="folderSelected === 'img' ? 'active' : ''" item-ref="img" @switch="changeFolder">
                              <template #icon>
                                <i class="fa-solid fa-image" :class="folderSelected === 'img' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
                              </template>
                            </SidenavFolderItem>
                          </li>
                        </ul>
                      </div>
                  </div>
                </div>
                <div class="col-lg-9 card scrollable" style="height: 32.9rem !important;">
                    <div class="card-body p-0">
                      <ImageList
                        v-if="folderSelected === 'img'"
                        :images='resources.images'
                        :errors='errors'
                        :entity-id='entityId'
                        :url='url'
                        :confirm-delete='confirmDelete'

                        @request-remove="updateDeleteConfirmation"
                        @error-handler="errorHandler"
                        @success-upload='upload'
                        @remove-item="remove"
                        @changed="upload($event)"
                      />
                      <DocumentList
                        v-if="folderSelected === 'doc'"
                        :documents='resources.documents'
                        :errors='errors'
                        :entity-id='entityId'
                        :url='url'
                        :confirm-delete='confirmDelete'

                        @request-remove="updateDeleteConfirmation"
                        @error-handler="errorHandler"
                        @success-upload='upload'
                        @remove-item="remove"
                        @changed="upload($event)"
                      />
                    </div>
                </div>
              <SnackBarNotification id="snackbar1" type="confirm">
                <template #content>
                  <div class="container my-4 font-weight-600 p-0">
                    <div class="row p-0">
                      <i class="col-lg-1 fa fa-info-circle" aria-hidden="true" style="font-size: 2em; color: #344767"></i>
                      <div class="col-lg-6 p-0">
                        {{ $t('key_filemodalselector_delete_confirmation') }}
                      </div>
                      <div class="col-lg-2">
                        <soft-button class="btn bg-white" color="primary" variant="outline" @click="confirmDelete = null; $forceUpdate(); toggleSnackBar('snackbar1')">{{ $t('key_cancel') }}</soft-button>
                      </div>
                      <div class="col-lg-3 text-end">
                        <soft-button class="btn bg-white" color="primary" variant="outline" @click="confirmDeleted">{{ $t('key_confirm') }}</soft-button>
                      </div>
                    </div>
                  </div>
                </template>
              </SnackBarNotification>
              <SnackBarNotification id="snackbar2" type="error">
                <template #content>
                  <div class="container p-0 font-weight-600">
                    <div class="row p-0 m-0" style="height: 18px !important">
                      <div class="col-lg-12 p-0 m-0 text-end">
                        <a
                          style="cursor:pointer"
                          title="Cerrar"
                          @click="toggleSnackBar('snackbar2')">
                          <i class="fa fa-window-close"></i>
                        </a>
                      </div>
                    </div>
                    <div class="row">
                      <i class="col-lg-1 fa fa-info-circle" aria-hidden="true" style="font-size: 2em; color: #344767"></i>
                      <div class="col-lg-5 p-0 text-start">
                        {{ errorMessage }}
                      </div>
                      <!-- div class="col-lg-6 p-0 text-end">
                        <button class="btn bg-white" @click="toggleSnackBar('snackbar2')">Ok</button>
                      </div-->
                    </div>
                  </div>
                </template>
              </SnackBarNotification>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button id="close" type="button" class="btn btn-outline-primary" data-bs-dismiss="modal" @click="closeModal" >
              {{ $t('key_close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import SoftButton from "@/components/SoftButton.vue";
  import SidenavFolderItem from "./SidenavFolderItem";
  import ImageList from "./ImageList.vue";
  import DocumentList from "./DocumentList.vue";
  import SnackBarNotification from './SnackBarNotification';

  export default {
    name: "FileModalSelector",
    components: {
      DocumentList,
      ImageList,
      SnackBarNotification,
      SidenavFolderItem,
      SoftButton
    },
    props: {
      resources: {
        type: Object,
        default: () => {
          return {
            'images': [],
            'documents': []
          };
        },
      },
      errors: {
        type: [ Object, String ],
        default: () => {
          return {
            'images': [],
            'documents': []
          };
        },
      },
      url: {
        type: String,
        default: '',
      },
      entityId: {
        type: String,
        default: '',
      },
      entityNumber: {
        type: String,
        default: '',
      }
    },
    emits: ['success','failure', 'upload', 'success-upload', 'remove-item', 'close-modal'],
    data() {
      return {
        folderSelected: 'doc',
        dataFile:{
          data:{tipo:''},
          batch: null,
        },
        isLoading: false,
        errorUpload: null,
        successUpload: null,
        errorRemove: null,
        successRemove: null,
        errorDownload: null,
        successDownload: null,
        confirmDelete: false,

        errorMessage: "",
        gallery: []
      }
    },
    computed: {
      btnUpload(){
        return this.dataFile.batch== null || this.dataFile.data.tipo=='';
      }
    },
    mounted() {
    },
    methods: {
      force() {
        if (this.confirmDelete != null && this.confirmDelete) {
          this.confirmDelete = null
        } else {
          this.confirmDelete = false
        }
        this.$forceUpdate()
      },
      toggleSnackBar(id) {
        var x = document.getElementById(id);
        if (x.style.transform == "scaleY(1)") {
          x.style.transform = "scaleY(0)";
          return
        }
        x.style.transform = "scaleY(1)";
      },
      hideSnackBar(id) {
        var x = document.getElementById(id);
        x.style.transform = "scaleY(0)";
      },
      errorHandler(msg) {
        this.toggleSnackBar("snackbar2")
        this.errorMessage = msg
      },
      updateDeleteConfirmation() {
        // this.force()
        var x = document.getElementById("snackbar1");
        if (x.style.transform == "scaleY(1)") {
          x.style.transform = "scaleY(0)";
          setTimeout(() => {
            x.style.transform = "scaleY(1)";
          }, 300)
          return
        }
        x.style.transform = "scaleY(1)";
      },
      changeFolder(folder) {
        this.folderSelected = folder
        this.hideSnackBar("snackbar1")
      },
      upload(data) {
        this.$emit('success-upload', data);
      },
      handleFileUpload(event) {
        this.$emit('upload', event);
      },
      remove(value) {
        this.$emit('remove-item', value);
        this.confirmDeleteImage = true
      },
      closeModal() {
        this.hideSnackBar("snackbar1")
        this.hideSnackBar("snackbar2")
        this.isLoading = false
        this.errorUpload = null
        this.successUpload = null
        this.errorRemove = null
        this.successRemove = null
        this.errorDownload = null
        this.successDownload = null
        this.confirmDelete = false
        this.$emit('close-modal');
        this.folderSelected = 'doc'
      },
      confirmDeleted() {
        this.confirmDelete = true;
        this.toggleSnackBar('snackbar1')
        setTimeout(() => {
          this.confirmDelete = false;
        }, 200)
      }
    }
  }
</script>

<style scoped>

  .card {
    box-shadow: none !important;
    border-left: 1px solid #dee2e6;
    border-radius: 0rem !important;
  }

  .icon-white {
    color: white !important;
  }

  .icon-primary {
    color: #4A7062 !important;
  }

  .modal-content1 {
    width: 65rem !important;
    margin-left: 7%
  }

  .modal-body1 {
    height: 550px !important;
    overflow-y: hidden !important
  }

</style>